import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

const waitInterval = 5000; // ms

@Injectable({ providedIn: 'root' })
export class NavigationService {

  private _isOpened: boolean;

  constructor(
    private readonly _router: Router,
    private readonly _translateService: TranslateService,
    private readonly _snackBar: MatSnackBar
  ) {
  }

  public goToUrl(path: string) {
    this._router.navigateByUrl(path).catch(() => {
      this.openSnackBar();
    }).catch(() => {
      window.location.href = window.location.origin + (path.startsWith('/cabinet') ? path : '/cabinet' + path);
    });
  }

  public openSnackBar(message?: string, action?: string) {
    if (this._isOpened) {
      return;
    }

    if (!message) {
      message = this._translateService.instant('common.error.offline');
    }
    if (!action) {
      action = this._translateService.instant('common.label.reload');
    }

    this._isOpened = true;
    const snackBarRef = this._snackBar.open(message, action, {
      duration: waitInterval,
      verticalPosition: 'bottom'
    });

    snackBarRef.onAction().subscribe(() => {
      window.location.reload();
    });
    snackBarRef.afterDismissed().subscribe(() => {
      this._isOpened = false;
    });
  }
}
